import {
    faDownload,
    faFileImport,
    faFilter,
    faPaperPlane,
    faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { useState, useEffect, ChangeEvent } from "react";
import { ColumnDescription, SelectRowProps } from "react-bootstrap-table-next";
import { useForm, FormProvider } from "react-hook-form";
import { FroalaEditor } from "../../../../Components/CardsPages/Forms/Editor/FroalaEditor";
import UnForm from "../../../../Components/Form";
import Table from "../../../../Components/Table";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import { ListarDocumentoTemplateController } from "../../../../Controllers/Geral/Documentos/DocumentosController";
import {
    ComunicarClienteEmLoteController,
    ListarClienteComunicadoEmLoteController,
} from "../../../../Controllers/Geral/GestaoClientes/GestaoClientesController";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import {
    ClienteEmLoteInterface,
    IClienteEmLoteFilter,
    IClienteSimples,
    IComunicarClienteEmLoteBody,
} from "../../../../Interfaces/Geral/GestaoClientes/GestaoClientesInterfaces";
import type * as CSS from "csstype";
import Select from "react-select";
import {
    ListarBlocosEmpreendimentoController,
    ListarEmpreendimentosController,
} from "../../../../Controllers/Geral/Produtos/ProdutosControllers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ListarEmailContaPorUsuarioController } from "../../../../Controllers/Geral/Grupos/GruposEmailsController";
import {
    EnviarMensagemAtivaEmMassaController,
    GerarModeloTemplateController,
} from "../../../../Controllers/HelpDesk/GestaoAtendimentos/GestaoAtendimentosControllers";
import { ListarMensagensTemplate } from "../../../../Services/HelpDesk/GestaoAtendimentos/GestaoAtendimentosService";
import { ValidationErr } from "../../../../Validations/ValidationError";
import { IMensagemTemplate } from "../../../../Interfaces/HelpDesk/Equipes/Atendimento/AtendimentoInterfaces";
import { formatedTelefone } from "../../../../Tools/FormatTools";
import { IComponentModal } from "../../../../Components/Modais/IModalComponent";
import ImportarPanilhaClientes from "./ImportarPanilhaClientes";
import ModalComponent from "../../../../Components/Modais";

import * as XLSX from "xlsx";
import "./styles.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useComunicadoClienteImportarPlanilhaContext } from "./ComunicadoClienteContext/ComunicadoClienteContext";
import { saveAs } from "file-saver";
import { Spinner } from "../../../../Components/Loding/SpinnerPadrao";

interface IComunicadoClienteProps {
    setShow: (show: boolean) => void;
}

interface htmlQuill {
    editorHtml: string;
}

type TTipoComunicacao = "Email" | "WhatsApp" | "SMS";

interface Style extends CSS.Properties, CSS.PropertiesHyphen {}

export default function ComunicadoCliente(props: IComunicadoClienteProps) {
    const { idModulo } = useAtendimentoPage();
    const FormMethods = useForm();
    const { formState } = FormMethods;
    const [normalText, setNormalText] = useState("");
    const filtroInicial = {
        ID_EMPREENDIMENTO: [],
        NR_PAGINA: 1,
        QUANTIDADE: 10,
        DS_BLOCOS: [],
    };
    const [idEmpreendimento, setIdEmpreendimento] = useState<string | number[]>(
        []
    );
    const [idBloco, setIdBloco] = useState<string[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const [lstClientes, setLstClientes] = useState<ClienteEmLoteInterface[]>(
        []
    );

    const [lstMessage, setLstMessage] = useState<IMensagemTemplate[]>([]);
    const [totalPagina, setTotalPagina] = useState<number>(0);

    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const [options, setOptions] = useState<
        Array<{ value: number; label: string }> | undefined
    >();
    const [optionsBloco, setOptionsBloco] = useState<
        Array<{ value: string; label: string }> | undefined
    >();
    const { execute: listarBloco } = useAsyncCallback(
        ListarBlocosEmpreendimentoController
    );

    const {
        file,
        setFile,
        lstClientesPlanilha,
        setLstClientesPlanilha,
        fileInputRef,
    } = useComunicadoClienteImportarPlanilhaContext();

    const {
        execute: EnviarMensagemAtivaEmMassa,
        loading: EnviarMensagemAtivaEmMassaLoading,
    } = useAsyncCallback(EnviarMensagemAtivaEmMassaController);

    const {
        execute: GerarModeloTemplate,
        loading: GerarModeloTemplateLoading,
    } = useAsyncCallback(GerarModeloTemplateController);

    const { value: listarEmpreendimentos } = useAsyncEffect(
        () => ListarEmpreendimentosController(),
        []
    );
    const [convertedText, setConvertedText] = useState<htmlQuill>(
        {} as htmlQuill
    );
    const [tipoComunicacao, setTipoComunicacao] = useState<TTipoComunicacao>();

    const [idDocumentoTemplate, setIdDocumentoTemplate] = useState<
        number | undefined
    >();

    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
            border: "1px solid #e4e6ef",
            transition:
                "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        }),
    };

    const [textoDocumentoTemplate, setTextoDocumentoTemplate] = useState<any>(
        {}
    );

    async function lstMensagemTemplate() {
        await ListarMensagensTemplate()
            .then((response) => {
                if (response.status === 200) {
                    setLstMessage(response.data);
                }
            })
            .catch((err) => {
                ValidationErr(err);
                throw err;
            });
    }

    useEffect(() => {
        if (tipoComunicacao !== "SMS") {
            setConvertedText({ editorHtml: textoDocumentoTemplate });
        } else {
            setNormalText(textoDocumentoTemplate);
        }
    }, [textoDocumentoTemplate, tipoComunicacao]);

    useEffect(() => {
        setOptions(() =>
            listarEmpreendimentos?.map((empreendimento) => ({
                label: empreendimento.DS_EMPREENDIMENTO,
                value: empreendimento.ID_EMPREENDIMENTO,
            }))
        );
    }, [listarEmpreendimentos]);
    useEffect(() => {
        updateTable(filtroInicial);
        lstMensagemTemplate();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const updateTable = (filtro: IClienteEmLoteFilter) => {
        setLoading(true);
        ListarClienteComunicadoEmLoteController(filtro)
            .then((response) => {
                setLstClientes(response.lstClientes);
                setTotalPagina(response.NR_PAGINAS);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const [lstSelecionados, setLstSelecionados] = useState<
        Array<IClienteSimples>
    >([]);
    const [enableNextStep, setEnableNextStep] = useState(false);
    const [emailsEnviados, setEmailsEnviados] = useState(0);
    let porcentagemTotal = (100 / lstSelecionados.length) * emailsEnviados;

    const {
        execute: gerarComunicadoEmLote,
        loading: gerarComunicadoEmLoteLoading,
    } = useAsyncCallback(ComunicarClienteEmLoteController);

    const { value: documentoTemplates } = useAsyncEffect(() =>
        ListarDocumentoTemplateController({
            idTipoCaso: idModulo,
            FL_NAO_CARREGA_TEMPLATE: false,
        })
    );

    function handleChange(e: string) {
        if (tipoComunicacao !== "SMS") {
            setConvertedText({ editorHtml: e });
        } else {
            setNormalText(textoDocumentoTemplate);
        }
    }

    const handleFileUpload = (e: ChangeEvent<HTMLInputElement>) => {
        const reader = new FileReader();

        if (e.target.files) {
            const uploadedFile = e.target.files[0];
            setFile(uploadedFile);

            reader.onload = (event) => {
                const data = event.target?.result;
                const workbook = XLSX.read(data, { type: "binary" });
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];
                const parsedData: any = XLSX.utils.sheet_to_json(sheet);
                setLstClientesPlanilha(parsedData);
            };

            reader.readAsBinaryString(uploadedFile);
        }
    };

    const handleFileRemove = () => {
        setFile(undefined);
        setLstClientesPlanilha([]);
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };

    async function handleGerarComunicado(
        formData: IComunicarClienteEmLoteBody
    ) {
        const lstSelecionadoFormatted: IClienteSimples[] = [];
        lstSelecionados.forEach((lst) => {
            if (lst?.NR_TELEFONE?.includes(";")) {
                const lstNumbers: string[] = lst.NR_TELEFONE.split(";");
                lstNumbers.map((number) => {
                    return lstSelecionadoFormatted.push({
                        ...lst,
                        NR_TELEFONE: number,
                    });
                });
            } else {
                lstSelecionadoFormatted.push(lst);
            }
        });
        if (lstClientesPlanilha) {
            console.log("primeiro if");
            for (let selecionados of lstClientesPlanilha) {
                if (tipoComunicacao)
                    await gerarComunicadoEmLote(
                        tipoComunicacao,
                        {
                            ...formData,
                            HTML_TEMPLATE: convertedText.editorHtml,
                            DADOS_DE_CONTATO_CLIENTE: {
                                DS_EMAIL: selecionados.DS_EMAIL,
                                NR_TELEFONE: selecionados.NR_TELEFONE,
                            },
                            ID_DOCUMENTO_TEMPLATE: idDocumentoTemplate,
                            DS_MENSAGEM: normalText,
                            DS_ASSUNTO: formData.DS_ASSUNTO,
                        },
                        formData.ID_EMAIL_CONTA
                    ).then((res) => {
                        if (res.message === "Ok") {
                            setEmailsEnviados((prev) => (prev += 1));
                        }
                    });
            }
        } else if (tipoComunicacao !== "WhatsApp") {
            console.log("segundo if");
            for (let selecionados of lstSelecionados) {
                if (tipoComunicacao)
                    await gerarComunicadoEmLote(
                        tipoComunicacao,
                        {
                            ...formData,
                            HTML_TEMPLATE: convertedText.editorHtml,
                            DADOS_DE_CONTATO_CLIENTE: {
                                DS_EMAIL: selecionados.DS_EMAIL,
                                NR_TELEFONE: selecionados.NR_TELEFONE,
                            },
                            ID_DOCUMENTO_TEMPLATE: idDocumentoTemplate,
                            DS_MENSAGEM: normalText,
                            DS_ASSUNTO: formData.DS_ASSUNTO,
                        },
                        formData.ID_EMAIL_CONTA
                    ).then((res) => {
                        if (res.message === "Ok") {
                            setEmailsEnviados((prev) => (prev += 1));
                        }
                    });
            }
        } else {
            console.log("else");
            if (idDocumentoTemplate)
                await EnviarMensagemAtivaEmMassa(
                    idDocumentoTemplate,
                    lstSelecionadoFormatted.map((lst) => ({
                        ddiNumDestino: lst.COD_DDI ?? "",
                        numDestinoSem9:
                            lst.NR_TELEFONE?.replace(/^9/, "") ?? "",
                    }))
                ).then((res) => {
                    if (res.message === "Ok") {
                        setEmailsEnviados((prev) => (prev += 1));
                    }
                });
        }

        porcentagemTotal = 0;
        setEmailsEnviados(0);
    }
    const style: Style = {
        height: "1px",
        width: "1px",
    };

    const selectRowProp: SelectRowProps<IClienteSimples> = {
        mode: "checkbox",
        clickToSelect: true,
        clickToEdit: true,
        onSelect: (row, isSelect) => {
            if (isSelect) {
                setLstSelecionados((lstSelecionadoValue) => [
                    ...lstSelecionadoValue,
                    row,
                ]);
            } else {
                setLstSelecionados((lstId) =>
                    lstId.filter((id) => id.ID_CONTA !== row.ID_CONTA)
                );
            }
            row.FL_SELECIONADO = isSelect;
            const lstClientesMarcados =
                lstClientes?.filter((p) => p.FL_SELECIONADO) ?? [];

            setEnableNextStep(lstClientesMarcados.length > 0);
        },
        onSelectAll: (isSelect, rows: Array<IClienteSimples>) => {
            if (isSelect) {
                setLstSelecionados((lstSelecionados) => [
                    ...lstSelecionados,
                    ...rows.map((contatos) => contatos),
                ]);
            } else {
                setLstSelecionados([]);
            }
            rows.forEach((row) => {
                row.FL_SELECIONADO = isSelect;
            });

            setEnableNextStep(isSelect);
        },
        nonSelectable:
            tipoComunicacao === "WhatsApp"
                ? lstClientes
                      .filter(
                          (cliente) =>
                              cliente.COD_DDI === null &&
                              cliente.NR_TELEFONE === null
                      )
                      .map((selecionados) => {
                          return selecionados.ID_CONTA;
                      })
                : undefined ||
                  (lstClientesPlanilha &&
                      lstClientesPlanilha.map((cliente) => cliente.ID_CONTA)),
    };

    const tableviewColumns: Array<ColumnDescription<ClienteEmLoteInterface>> = [
        {
            dataField: "ID_CONTA",
            text: "",
            style: style,
            isDummyField: true,
        },
        {
            dataField: "NR_TELEFONE",
            text: "Telefone",
            formatter: (c) => (c ? formatedTelefone(c) : "-"),
        },
        {
            dataField: "DS_CONTA",
            text: "Nome",
        },
        {
            dataField: "DS_EMAIL",
            text: "Email",
            // formatter: (c, row) => (
            //     <div>
            //         {/*@ts-ignore*/}
            //         {c.map((telefone) => (
            //             <p>{telefone}</p>
            //         ))}
            //     </div>
            // ),
        },
        {
            dataField: "DS_EMPREENDIMENTO",
            text: "Empreendimento",
        },
        {
            dataField: "DS_BLOCO",
            text: "Bloco",
        },
    ];

    return (
        <div>
            <FormProvider {...FormMethods}>
                <UnForm
                    className="col-12"
                    handleSubmit={handleGerarComunicado}
                    usingContext
                >
                    <div className="col-12 d-flex mt-3 p-0">
                        <div className="col-6">
                            <UnForm.Select
                                className="mb-5 p-0 "
                                name="ID_CASO"
                                label="Envio Por: "
                                onChange={(e) =>
                                    setTipoComunicacao(
                                        e.target.value as TTipoComunicacao
                                    )
                                }
                            >
                                <option></option>
                                <option>Email</option>
                                <option>WhatsApp</option>
                                <option>SMS</option>
                            </UnForm.Select>
                        </div>

                        <div className="col-6">
                            <UnForm.Select
                                label="Template de Email:"
                                registerOptions={{
                                    required: "Escolha um template de email",
                                }}
                                name="idDocumentoTemplate"
                                className={`placeholder-dark-50 p-0 mb-5 ${
                                    formState.errors.ID_MODELO_EMAIL &&
                                    "is-invalid"
                                }`}
                                onChange={(e) => {
                                    const idTemplateEmail = Number.parseInt(
                                        e.target.value
                                    );

                                    setIdDocumentoTemplate(
                                        tipoComunicacao === "WhatsApp"
                                            ? lstMessage.find(
                                                  (doc) =>
                                                      doc.DS_CORPO_TEMPLATE ===
                                                      e.target.value
                                              )?.ID_DOCUMENTO_TEMPLATE
                                            : idTemplateEmail
                                    );
                                    tipoComunicacao === "WhatsApp"
                                        ? setTextoDocumentoTemplate(
                                              lstMessage.find(
                                                  (doc) =>
                                                      doc.DS_CORPO_TEMPLATE ===
                                                      e.target.value
                                              )?.DS_CORPO_TEMPLATE
                                          )
                                        : setTextoDocumentoTemplate(
                                              documentoTemplates?.find(
                                                  (documento) =>
                                                      documento.ID_DOCUMENTO_TEMPLATE ===
                                                      idTemplateEmail
                                              )?.DS_TEMPLATE
                                          );
                                }}
                            >
                                <option>Modelo de email</option>
                                {tipoComunicacao === "WhatsApp"
                                    ? lstMessage &&
                                      lstMessage.map((mensagem) => {
                                          return (
                                              <option
                                                  key={
                                                      mensagem.ID_DOCUMENTO_TEMPLATE
                                                  }
                                                  value={
                                                      mensagem.DS_CORPO_TEMPLATE
                                                  }
                                              >
                                                  {mensagem.DS_CORPO_TEMPLATE}
                                              </option>
                                          );
                                      })
                                    : documentoTemplates &&
                                      documentoTemplates.map((doc) => {
                                          return (
                                              <option
                                                  key={doc.ID_DOC_UNICO}
                                                  value={
                                                      doc.ID_DOCUMENTO_TEMPLATE
                                                  }
                                              >
                                                  {doc.DS_DOCUMENTO}
                                              </option>
                                          );
                                      })}
                            </UnForm.Select>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-6">
                            {tipoComunicacao === "Email" && (
                                <UnForm.Input
                                    label="Assunto:"
                                    type="text"
                                    name="DS_ASSUNTO"
                                    autoComplete="off"
                                    className={`form-control px-0 p-2 placeholder-muted-75 ${
                                        formState.errors.assunto && "is-invalid"
                                    }`}
                                    registerOptions={{
                                        required: "Insira o Assunto do E-mail",
                                    }}
                                />
                            )}
                        </div>
                        <div className="col-6">
                            {tipoComunicacao === "Email" && (
                                <UnForm.LazySelect
                                    label="Email Conta:"
                                    name="ID_EMAIL_CONTA"
                                    autoComplete="off"
                                    className={`form-control px-0 p-2 placeholder-muted-75 ${
                                        formState.errors.assunto && "is-invalid"
                                    }`}
                                    controller={
                                        ListarEmailContaPorUsuarioController
                                    }
                                    getKeyValue={(u) => u.ID_EMAIL_CONTA}
                                    getDS={(u) => u.DS_REMETENTE}
                                    registerOptions={{
                                        required: "Insira um do E-mail",
                                    }}
                                />
                            )}
                        </div>
                    </div>
                    <div className="col-12 mt-5">
                        <>
                            {/* {uploading && (
                                <div className="d-flex align-items-center justify-content-center g-2 p-2">
                                    Fazendo upload de imagem{" "}
                                    <Spinner size="sm" color="primary" />
                                </div>
                            )} */}

                            <FroalaEditor
                                value={convertedText.editorHtml}
                                onChange={handleChange}
                            />
                        </>
                    </div>

                    <UnForm.SubmitButton
                        wrapperClassName="col-12 d-flex justify-content-end"
                        className="col-4 mt-4 mb-4"
                        color="primary"
                        icon={faPaperPlane}
                        loading={
                            gerarComunicadoEmLoteLoading ||
                            EnviarMensagemAtivaEmMassaLoading
                        }
                        loadingSize="sm"
                        disabled={
                            !tipoComunicacao ||
                            gerarComunicadoEmLoteLoading ||
                            EnviarMensagemAtivaEmMassaLoading ||
                            (!lstClientesPlanilha.length && !enableNextStep)
                        }
                    >
                        Enviar Comunicado
                    </UnForm.SubmitButton>
                </UnForm>
            </FormProvider>
            {gerarComunicadoEmLoteLoading ? (
                <div>
                    <span>
                        {emailsEnviados} Email enviado de{" "}
                        {lstSelecionados.length}
                    </span>
                    <progress
                        className="w-100"
                        value={porcentagemTotal}
                        max="100"
                    ></progress>
                </div>
            ) : (
                <>
                    <div className="d-flex">
                        <div className="col-6 mb-3">
                            <label>Empreendimento</label>
                            <Select
                                name="ID_EMPREENDIMENTO"
                                options={options}
                                isClearable
                                isMulti
                                onChange={(e) => {
                                    setIdEmpreendimento(
                                        e.map((value) => value?.value)
                                    );
                                    listarBloco(
                                        e.map((value) => value?.value)
                                    ).then((response) => {
                                        setOptionsBloco(() =>
                                            response?.map((produto) => ({
                                                label: `${produto.DS_BLOCO} - ${produto.DS_EMPREENDIMENTO}`,
                                                value: produto.DS_BLOCO,
                                            }))
                                        );
                                    });
                                }}
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                }}
                                styles={customStyles}
                                placeholder={""}
                                noOptionsMessage={() => "Nenhuma opção"}
                            />
                        </div>
                        <div className={`col-6 mb-3`}>
                            <label>Bloco</label>
                            <Select
                                name="ID_BLOCO"
                                options={optionsBloco}
                                isClearable
                                onChange={(e) => {
                                    setIdBloco(e.map((value) => value?.value));
                                }}
                                isMulti
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                }}
                                styles={customStyles}
                                placeholder={""}
                                noOptionsMessage={() => "Nenhuma opção"}
                            />
                        </div>
                    </div>
                    <div className="w-100 my-3 d-flex justify-content-between p-2">
                        <div className="d-flex justify-content-center">
                            <div>
                                <label htmlFor="formFile" className="mb-0 w-75">
                                    Importar Planilha
                                </label>
                                <div className="custom-file mr-2 mt-1">
                                    <input
                                        type="file"
                                        className="custom-file-input pt-6 w-50"
                                        accept=".xlsx, .xls"
                                        id="formFile"
                                        onChange={handleFileUpload}
                                        ref={fileInputRef}
                                    />
                                    <label
                                        className="custom-file-label"
                                        htmlFor="formFile"
                                    >
                                        {file?.name || "Escolher arquivo..."}
                                    </label>
                                </div>
                            </div>

                            {file && (
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="ver-info-tooltip">
                                            Remover arquivo
                                        </Tooltip>
                                    }
                                >
                                    <button
                                        onClick={handleFileRemove}
                                        className="btn mr-1 mt-6 mb-1"
                                    >
                                        <FontAwesomeIcon
                                            icon={faTimes}
                                            color="red"
                                        />
                                    </button>
                                </OverlayTrigger>
                            )}
                            {lstClientesPlanilha?.length > 0 && (
                                <button
                                    className="btn btn-light-info w-25 mt-7"
                                    onClick={() => {
                                        setShow(true);
                                        setModal({
                                            Component: () => (
                                                <ImportarPanilhaClientes />
                                            ),
                                            headerComponent:
                                                "Dados da planilha",
                                            IconHeader: faFileImport,
                                            size: "xl",
                                            scrollable: true,
                                        });
                                    }}
                                >
                                    <FontAwesomeIcon icon={faFileImport} />{" "}
                                    Conferir Dados
                                </button>
                            )}
                        </div>
                        <div className="mt-7 d-flex">
                            <button
                                className="btn btn-success w-100 mr-2 p-1 pl-3 pr-0 d-flex align-items-center"
                                onClick={() => {
                                    GerarModeloTemplate({
                                        NR_PAGINA: 0,
                                        QUANTIDADE: 10,
                                        DS_BLOCOS: idBloco,
                                        ID_EMPREENDIMENTO: idEmpreendimento,
                                    }).then((res) => {
                                        saveAs(
                                            new Blob([res], {
                                                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                            }),
                                            "Template_Padrao.xlsx"
                                        );
                                    });
                                }}
                            >
                                {GerarModeloTemplateLoading ? (
                                    <Spinner size="sm" />
                                ) : (
                                    <FontAwesomeIcon
                                        icon={faDownload}
                                        className="mr-1"
                                    />
                                )}{" "}
                                Baixar Modelo Template
                            </button>
                            <button
                                className="btn btn-primary w-100"
                                onClick={() =>
                                    updateTable({
                                        NR_PAGINA: 1,
                                        QUANTIDADE: 10,
                                        ID_EMPREENDIMENTO: idEmpreendimento,
                                        DS_BLOCOS: idBloco,
                                    })
                                }
                            >
                                <FontAwesomeIcon
                                    icon={faFilter}
                                    className="mr-3"
                                />{" "}
                                Filtrar Clientes
                            </button>
                        </div>
                    </div>

                    <Table
                        selectRow={selectRowProp}
                        columns={tableviewColumns}
                        data={lstClientes ?? []}
                        loading={loading}
                        keyField={"ID_CONTA"}
                        remote={{ pagination: true }}
                        onTableChange={(type, newState) => {
                            updateTable({
                                NR_PAGINA: newState.page,
                                QUANTIDADE: 10,
                                ID_EMPREENDIMENTO: idEmpreendimento,
                                DS_BLOCOS: idBloco,
                            });
                        }}
                        noDataIndication={() => (
                            <div className="text-black-50 text-center">
                                Nenhum Registro de Hora Encontrado
                            </div>
                        )}
                        noSearch
                        sizePerPage={10}
                        noHover
                        totalPages={totalPagina}
                        bordered={false}
                        defaultStyle={{
                            align: "center",
                            classes: "p-2",
                        }}
                        striped={true}
                    />
                </>
            )}
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </div>
    );
}
